module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_14.0ef8e7c0.pdf";